import { API_ENDPOINTS, API_HEADERS } from '../constants/api';

export interface DirectorPayload {
  id: number;
  description: string;
  [key: string]: any;
}

export const fetchDirector = async (): Promise<DirectorPayload | null> => {
  const response = await fetch(API_ENDPOINTS.director, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Director request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as DirectorPayload) : null;
  }

  return data as DirectorPayload;
};
